export const transformToSelectData = (data) => {
  return data.map(({ id, name, ...rest }) => ({
    value: id,
    label: name,
    ...rest,
  }));
};

/** Para MainProduct (id, productName). */
export const transformMainProductsToSelectData = (data) =>
  (data || []).map((item) => ({
    value: item.id ?? item.Id,
    label: item.productName ?? item.ProductName,
  }));

export const status_select = [
  {
    value: 0,
    label: "Inactivo",
  },
  {
    value: 1,
    label: "Activo",
  },
];

/** Licencia por usuario en lab: 1 Activa, 2 Suspendida, 3 Vencida */
export const user_license_status_select = [
  { value: 1, label: "Activa" },
  { value: 2, label: "Suspendida" },
  { value: 3, label: "Vencida" }
];

export const months_select = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];
